<template>
  <div>
    <section-collapseable
      title="Property Details"
    >
      <p class="property_detail_summary" v-html="propertySummary"></p>

      <div class="mt-100 flex flex-between">
        <button-link
          :color="hotMotivatorColor"
          @click="openHotMotivatorsModal"
        >
          Hot Motivators {{ hotMotivatorCount.yes }}/{{ hotMotivatorCount.total}}
        </button-link>

        <button-outlined @click="openPropertyInfoModal">More Property Info</button-outlined>
      </div>
    </section-collapseable>

    <modal-container>
      <modal-default
        ref="propertyInfoModal"
        title="Property Data"
        is-triple-column
      >
        <property-modal :property="property"/>
      </modal-default>

      <modal-default
        ref="hotMotivatorModal"
        title="Hot Motivators"
        is-triple-column
      >
        <hot-motivator-modal :property="property"/>
      </modal-default>
    </modal-container>
  </div>
</template>

<script>
import PropertyModal from "../PropertyModal.vue";
import HotMotivatorModal from "../HotMotivatorModal.vue";
import utils from "../../../services/utils";

export default {
  name: "LeadPropertyDetails",
  components: {HotMotivatorModal, PropertyModal},
  computed: {
    property() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.property : {
        bedrooms: null,
        bathrooms: null,
        year_built: null,
        house_size: null,
        lot_size: null,
        parking_type: null,
        market_value: null,
        assessed_value: null,
        basement_size: null,
        stories: null,
        cooling_type: null,
        heating_type: null,
        construction_type: null,
        architecture_type: null,
        subdivision: null,
        amenities: null,
      };
    },
    propertySummary() {
      const bedrooms = this.property.bedrooms ? this.property.bedrooms : '--';
      const baths = this.property.bathrooms ? this.property.bathrooms : '--';
      const year = this.property.year_built ? this.property.year_built : '--';
      const sqft = this.property.house_size ? this.property.house_size : '--';
      const lotSize = this.property.lot_size ? this.property.lot_size : '--';

      return bedrooms + ' bedrooms | ' + baths + ' baths | built in ' + year + '<br>' + sqft + ' sq ft | ' + lotSize + ' lot size';
    },
    hotMotivatorCount() {
      const hotMotivators = utils.getHotMotivatorsFromRealPropertyData(this.property);

      return {
        yes: Object.values(hotMotivators).reduce((a, item) => a + item, 0),
        total: Object.keys(hotMotivators).length,
      }
    },
    hotMotivatorColor() {
      if(this.hotMotivatorCount.yes >= 2) return 'is-primary'
      return ''
    }
  },
  methods: {
    openHotMotivatorsModal() {
      this.$refs.hotMotivatorModal.open();
    },
    openPropertyInfoModal() {
      this.$refs.propertyInfoModal.open();
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.property_detail_summary {
  line-height: 1.7;
}
</style>
